import { AUTO, DESKTOP_FORM_POPUP, EVEN_TRIGGER_CODE, NEW_LEAD_FORM_DESKTOP_FORM_POPUP_AUTO, NEW_LEAD_FORM_DESKTOP_FORM_POPUP_USER, OLD_LEAD_FORM_DESKTOP_FORM_POPUP_AUTO, OLD_LEAD_FORM_DESKTOP_FORM_POPUP_USER, USER, V0_OLD_LEAD_FORM_DESKTOP_FORM_POPUP_AUTO, V0_OLD_LEAD_FORM_DESKTOP_FORM_POPUP_USER, VERSION_1_NEW_LEAD_FORM, VERSION_1_OLD_LEAD_FORM,VERSION_0_OLD_LEAD_FORM } from "../../constants/leadFormConstants";
import { gtmCustomEvent, gtmPageView } from "../../util/gtmTrigger";
import { checkIfToShowWhichLeadFormBasedOnCity } from "../../util/leadFormUtility";

export const processGtmDatalayer = (gtm, doPushDataLayer) => {
    if (doPushDataLayer) {
        let dataLayer = window.dataLayer;
        if (dataLayer) {
            if (doPushDataLayer.hasOwnProperty('first')) {
                dataLayer.push(doPushDataLayer.first);
            }
            if (doPushDataLayer.hasOwnProperty('second')) {
                dataLayer.push(doPushDataLayer.second);
            }
        }
    }

    if (gtm && gtm.gtmPageView1) {
        gtmPageView(gtm.gtmPageView1);
    }

    if (gtm && gtm.customEvent) {
        gtmCustomEvent(gtm.customEvent.category, gtm.customEvent.action, gtm.customEvent.label);
    }
    if (gtm && gtm.customEvent1) {
        gtmCustomEvent(gtm.customEvent1.category, gtm.customEvent1.action, gtm.customEvent1.label);
    }
    if (gtm && gtm.customEvent2) {
        gtmCustomEvent(gtm.customEvent2.category, gtm.customEvent2.action, gtm.customEvent2.label);
    }

    if (gtm && gtm.gtmPageView2) {
        gtmPageView(gtm.gtmPageView2);
    }
}

export const processCategoryForNewOldLeadForm = (isEven = null) => {
    const NEW_ENQUIRY_FORM = 'New Enquiry Form';
    const ENQUIRY_FORM = 'Old Enquiry Form';
    const V0_OLD_ENQUIRY_FORM = 'V0 Old Enquiry Form';
    // if (isEven) {
    //     return isEven === EVEN_TRIGGER_CODE ? NEW_ENQUIRY_FORM : ENQUIRY_FORM;
    // }
    // return NEW_ENQUIRY_FORM;
    if (checkIfToShowWhichLeadFormBasedOnCity()) {
        return V0_OLD_ENQUIRY_FORM;
    } else {
        return NEW_ENQUIRY_FORM;
    }
}

export const processActionForNewOldLeadForm = (isEven = null) => {
    const NEW_ENQUIRY_FORM = 'New Enquiry Form Popup';
    const ENQUIRY_FORM = 'Old Enquiry Form Popup';
    const V0_OLD_ENQUIRY_FORM = 'V0 Old Enquiry Form Popup';
    // if (isEven) {
    //     return isEven === EVEN_TRIGGER_CODE ? NEW_ENQUIRY_FORM : ENQUIRY_FORM;
    // }
    // return NEW_ENQUIRY_FORM;
    if (checkIfToShowWhichLeadFormBasedOnCity()) {
        return V0_OLD_ENQUIRY_FORM;
    } else {
        return NEW_ENQUIRY_FORM;
    }
}

export const processPageViewForNewOldLeadForm = (isEven = null, isAutoOrUser) => {
    // if (isEven && isEven === EVEN_TRIGGER_CODE) {
    //     if (isAutoOrUser === AUTO) {
    //         return NEW_LEAD_FORM_DESKTOP_FORM_POPUP_AUTO
    //     } else {
    //         return NEW_LEAD_FORM_DESKTOP_FORM_POPUP_USER
    //     }
    // } else {
    //     if (isAutoOrUser === AUTO) {
    //         return OLD_LEAD_FORM_DESKTOP_FORM_POPUP_AUTO
    //     } else {
    //         return OLD_LEAD_FORM_DESKTOP_FORM_POPUP_USER
    //     }
    // }
    if (checkIfToShowWhichLeadFormBasedOnCity()) {
        if (isAutoOrUser === AUTO) {
            return V0_OLD_LEAD_FORM_DESKTOP_FORM_POPUP_AUTO
        } else {
            return V0_OLD_LEAD_FORM_DESKTOP_FORM_POPUP_USER
        }
    } else {
        if (isAutoOrUser === AUTO) {
            return NEW_LEAD_FORM_DESKTOP_FORM_POPUP_AUTO
        } else {
            return NEW_LEAD_FORM_DESKTOP_FORM_POPUP_USER
        }
    }
}

export const processPageViewUrlForNewOldLeadForm = (isEven = null, url, isAutoOrUser) => {
    // if (isEven && isEven === EVEN_TRIGGER_CODE) {
    //     if (isAutoOrUser === AUTO) {
    //         return `${VERSION_1_NEW_LEAD_FORM}/${url}/${DESKTOP_FORM_POPUP}/${AUTO}`
    //     } else {
    //         return `${VERSION_1_NEW_LEAD_FORM}/${url}/${DESKTOP_FORM_POPUP}/${USER}`
    //     }
    // } else {
    //     if (isAutoOrUser === AUTO) {
    //         return `${VERSION_1_OLD_LEAD_FORM}/${url}/${DESKTOP_FORM_POPUP}/${AUTO}`
    //     } else {
    //         return `${VERSION_1_OLD_LEAD_FORM}/${url}/${DESKTOP_FORM_POPUP}/${USER}`
    //     }
    // }
    if (checkIfToShowWhichLeadFormBasedOnCity()) {
        if (isAutoOrUser === AUTO) {
            return `${VERSION_0_OLD_LEAD_FORM}/${url}/${DESKTOP_FORM_POPUP}/${AUTO}`
        } else {
            return `${VERSION_0_OLD_LEAD_FORM}/${url}/${DESKTOP_FORM_POPUP}/${USER}`
        }
    } else {
        if (isAutoOrUser === AUTO) {
            return `${VERSION_1_NEW_LEAD_FORM}/${url}/${DESKTOP_FORM_POPUP}/${AUTO}`
        } else {
            return `${VERSION_1_NEW_LEAD_FORM}/${url}/${DESKTOP_FORM_POPUP}/${USER}`
        }
    }
}